import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { Toaster } from 'react-hot-toast';
import HomePage from './pages/HomePage';
import BoardPage from './pages/BoardPage';
import TemplateSelectionPage from './pages/TemplateSelectionPage';
import TeamsPage from './pages/TeamsPage';
import { SocketProvider } from './context/SocketContext';
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import msalConfig from './config/msalConfig';
import './App.css';

// Development API connectivity test
import './utils/apiTest';

// Create MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

function App() {
  return (
    <div className="App">
      <MsalProvider instance={msalInstance}>
        <AuthProvider>
          <Router>
            <ProtectedRoute>
              <SocketProvider>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/templates" element={<TemplateSelectionPage />} />
                  <Route path="/teams" element={<TeamsPage />} />
                  <Route path="/board/:boardId" element={<BoardPage />} />
                </Routes>
                <Toaster 
                  position="top-right"
                  toastOptions={{
                    duration: 3000,
                    style: {
                      background: '#363636',
                      color: '#fff',
                    },
                  }}
                />
              </SocketProvider>
            </ProtectedRoute>
          </Router>
        </AuthProvider>
      </MsalProvider>
    </div>
  );
}

export default App;